import type { Company } from 'src/secret-menu/hooks/useCompanies';

export type BrandAssetBuilderPalette = {
  primary: string;
  secondary: string;
  accent: string;
  darkText: string;
  background: string;
};

export type BrandAssetBuilderTitlePageTheme =
  | 'layered-wave'
  | 'soft-horizon'
  | 'diagonal-sweep'
  | 'stepped-horizon'
  | 'corner-swell'
  | 'opposing-ribbons'
  | 'corner-cut'
  | 'crescent-arc';

export type BrandAssetBuilderShapeColour = 'primary' | 'secondary' | 'accent' | 'darkText';

export type BrandAssetBuilderLogoPosition = 'left' | 'center' | 'right';

export type BrandAssetBuilderTitlePageConfig = {
  shapeColor: BrandAssetBuilderShapeColour;
  logoScale: number;
  logoPosition: BrandAssetBuilderLogoPosition;
  logoX: number;
  logoY: number;
  hideDate: boolean;
};

export type BrandAssetBuilderData = {
  company: Company | null;
  clientName: string;
  logoFile: File | null;
  logoUrl: string | null;
  palette: BrandAssetBuilderPalette;
  headingFont: string;
  bodyFont: string;
  titlePageTheme: BrandAssetBuilderTitlePageTheme;
  titlePageConfig: BrandAssetBuilderTitlePageConfig;
};

export const DEFAULT_BRAND_ASSET_BUILDER_PALETTE: BrandAssetBuilderPalette = {
  primary: '#E7E7E7',
  secondary: '#878787',
  accent: '#4B4B4B',
  darkText: '#1A1A1A',
  background: '#FFFFFF',
};

export const initialBrandAssetBuilderData: BrandAssetBuilderData = {
  company: null,
  clientName: '',
  logoFile: null,
  logoUrl: null,
  palette: DEFAULT_BRAND_ASSET_BUILDER_PALETTE,
  headingFont: 'Calibri',
  bodyFont: 'Calibri',
  titlePageTheme: 'layered-wave',
  titlePageConfig: {
    shapeColor: 'primary',
    logoScale: 100,
    logoPosition: 'center',
    logoX: 50,
    logoY: 15,
    hideDate: false,
  },
};
